import ProTable from './pro-table';
export default ProTable;
